import axios from "fetch-api/fetch-api";
import { IVehicle } from "interfaces/session/IVehicle";
import { getFitmentOptionQS } from "../../util/vehicle/get-fitment-option-q-s";
import { ICategory, IGetFittingProductPriceRangeResponse } from "../interfaces/category-api.type";

function getFittingProductPriceRange(vehicle: IVehicle, category: ICategory) {
  const { fitmentOptions, colorData, ...selectedVehicle } = vehicle;
  const fitmentOptionQS = getFitmentOptionQS(fitmentOptions, true);

  return axios.get<IGetFittingProductPriceRangeResponse>(`s/get-fitting-product-price-range?${fitmentOptionQS}`, {
    params: {
      ...selectedVehicle,
      ...category,
    },
  });
}
export default getFittingProductPriceRange;
